








import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import Invoice from './Invoice.vue';

@Component
export default class InvoiceNoteLine extends Vue {
  @Prop() private note!: string;
  @Inject() public documentComponent!: Invoice;

  public get colspan() {
    let colspan = 7;
    if (this.documentComponent.displaySettings.invoiceLineOrderedQuantity) colspan += 1;
    if (this.documentComponent.displayLineAllowanceChargeColumn) colspan += 1;
    if (this.documentComponent.displaySettings.invoiceLineTaxAmount) colspan += 1;
    return colspan;
  }
}
